//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.component('searchFilterCheckboxGroup', {
    bindings: {
      label: '@',
      alias: '@',
      isRightAligned: '<',
    },
    require: {
      searchFilter: '^searchFilter',
    },
    transclude: true,
    template: require('@legacy-components/filters/search-filter-checkbox-group.html'),
    controller: ['$sce', '$scope', '$timeout', 'SearchFilterService',
      function($sce, $scope, $timeout, SearchFilterService) {
        const self = this;

        self.checked = false;
        self.isIndeterminate = false;
        self.groupOptions = [];

        const DEFAULT_POPOVER_CONFIG = {
          fixed: ['right', 'left'],
          align: ['top', 'bottom'],
        };

        const RIGHT_POPOVER_CONFIG = {
          fixed: ['bottom', 'top'],
          align: ['right', 'left'],
        };

        const registerAlias = _.debounce(() => {
          const aliasObject = {
            alias: self.alias,
            values: self.groupOptions,
          };

          SearchFilterService.registerGroupAlias(self.searchFilter.searchFilterSet.name, aliasObject);
        }, 10);

        const calculateCheckboxStatus = function(newStateValues) {
          const groupValuesInNewState = _(newStateValues).intersection(self.groupOptions);

          $scope.$applyAsync(() => {
            self.checked = self.groupOptions.length === groupValuesInNewState.length;
            self.isIndeterminate = !self.checked && !_(groupValuesInNewState).isEmpty();
          });
        };

        this.registerGroupValue = function(value) {
          if (!_(self.groupOptions).contains(value)) {
            self.groupOptions.push(value);
            registerAlias();
          }
        };

        self.checkboxGroupChanged = function() {
          self.checked = !(self.checked || self.isIndeterminate);
          if (self.checked) {
            self.searchFilter.addValues(angular.copy(self.groupOptions));
          } else {
            self.searchFilter.removeValues(angular.copy(self.groupOptions));
          }
        };

        self.$onInit = function() {
          self.popoverConfig = self.isRightAligned ? RIGHT_POPOVER_CONFIG : DEFAULT_POPOVER_CONFIG;
          self.popoverOffset = self.isRightAligned ? 0 : undefined;

          const currentState = self.searchFilter.getValue();
          self.lockedKey = self.searchFilter.isKeyLocked();
          $scope.$applyAsync(() => {
            calculateCheckboxStatus(currentState);
          });

          self.searchFilter.getFilterValueStream().subscribe((newState) => {
            calculateCheckboxStatus(newState);
          });
        };
      },
    ],
  });
})();
